import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-24 h-24 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-6">
          <i className="ri-emotion-sad-line text-4xl"></i>
        </div>
        <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
          404 - 页面未找到
        </h1>
        <p className="text-foreground-500 text-sm mb-6">
          您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line mr-2"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}